module.exports = __webpack_public_path__ + "static/img/yeyuqiudeng.db3218a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yeyuqiudeng.jpg
// module id = Pyx6
// module chunks = 1